import Vue from 'vue';
import Router from 'vue-router';
import Login from '../pages/Login';
import BindUser from '../pages/BindUser';
import BindWeixin from '../pages/BindWeixin';
import SmsLogin from '../pages/sms/SmsLogin';
import ForgotPassword from '../pages/ForgotPassword';
import ResetUser from '../pages/ResetUser';
import Account from '../pages/Account';

import Applications from '../pages/Applications';
import AppManage from '../pages/AppManage';
import AppUsers from '../pages/AppUsers';

import HamletUsers from '../pages/HamletUsers';
import Logs from '../pages/Logs';

// import store from '../store';

Vue.use(Router);
const root = Vue.component('root', {
  template: '<router-view></router-view>',
});

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      hidden: true,
    },
    component: Login,
  },
  {
    path: '/',
    component: root,
    redirect: { name: 'applications' },
    meta: {
      auth: ['root', null, ''],
    },
    children: [
      {
        path: 'apps',
        name: 'applications',
        meta: {
          auth: ['root', null, ''],
        },
        component: Applications,
      },
      {
        path: 'apps/edit/:appId',
        name: '',
        component: root,
        children: [
          {
            path: '',
            name: 'app_manage',
            meta: {
              auth: ['root', null, ''],
            },
            component: AppManage,
          },
        ],
        meta: {
          auth: ['root', null, ''],
          hidden: true,
        },
      },
      {
        path: 'app_users',
        name: 'app_users',
        meta: {
          auth: ['root', null, ''],
        },
        component: AppUsers,
      },
      {
        path: 'users',
        name: 'user',
        meta: {
          auth: ['root'],
        },
        component: HamletUsers,
      },
      {
        path: 'logs',
        name: 'logs',
        meta: {
          auth: ['root', null, ''],
        },
        component: Logs,
      },
      {
        path: 'reset',
        name: 'reset',
        meta: {
          auth: ['root', null, ''],
          hidden: true,
        },
        component: Account,
      },
    ],
  },
  {
    path: '/bind',
    name: 'Bind',
    meta: {
      hidden: true,
    },
    component: BindUser,
  },
  {
    path: '/bind/weixin',
    name: 'BindWeixin',
    meta: {
      hidden: true,
    },
    component: BindWeixin,
  },
  {
    path: '/sms/login',
    name: 'SmsLogin',
    meta: {
      hidden: true,
    },
    component: SmsLogin,
  },
  {
    path: '/unbind',
    name: 'ApplyForUnbind',
    meta: {
      hidden: true,
    },
    component: BindWeixin,
  },
  {
    path: '/forgot_password',
    name: 'ForgotPassword',
    meta: {
      hidden: true,
    },
    component: ForgotPassword,
  },
  {
    path: '/reset_password',
    name: 'Reset',
    meta: {
      hidden: true,
    },
    component: ResetUser,
  },
  {
    path: '*',
    redirect: { path: '/404' },
  },
];

const router = new Router({
  mode: 'history',
  routes,
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js